/* The Homely Habit - recently viewed products on the product page */
(function () {
  var KEY = 'hh_recently_viewed';
  var MAX_STORE = 12;
  var MAX_SHOW = 4;

  function handleFromPath() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORE))); } catch (e) {}
  }

  function remember(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
    } catch (e) { return '£' + (cents / 100).toFixed(2); }
  }

  function thumb(url) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_600x600_crop_center$1$2');
  }

  function card(p) {
    var a = document.createElement('a');
    a.className = 'hh-rv__card';
    a.href = p.url;

    var img = document.createElement('img');
    img.className = 'hh-rv__img';
    img.loading = 'lazy';
    img.alt = p.title;
    if (p.featured_image) img.src = thumb(p.featured_image);
    a.appendChild(img);

    var t = document.createElement('p');
    t.className = 'hh-rv__name';
    t.textContent = p.title;
    a.appendChild(t);

    var pr = document.createElement('p');
    pr.className = 'hh-rv__price';
    pr.textContent = money(p.price);
    a.appendChild(pr);

    return a;
  }

  function anchor() {
    var sections = document.querySelectorAll('[id^="shopify-section-"]');
    var last = null;
    for (var i = 0; i < sections.length; i++) {
      var id = sections[i].id;
      if (/product_list_/.test(id)) last = sections[i];
    }
    if (last) return last;
    for (var j = sections.length - 1; j >= 0; j--) {
      if (!/footer|cart-drawer/.test(sections[j].id)) return sections[j];
    }
    return null;
  }

  function render(products) {
    if (!products.length) return;
    if (document.querySelector('.hh-rv')) return;
    var target = anchor();
    if (!target) return;

    var wrap = document.createElement('section');
    wrap.className = 'hh-rv';

    var h = document.createElement('h2');
    h.className = 'hh-rv__title';
    h.textContent = 'Recently viewed';
    wrap.appendChild(h);

    var grid = document.createElement('div');
    grid.className = 'hh-rv__grid';
    products.forEach(function (p) { grid.appendChild(card(p)); });
    wrap.appendChild(grid);

    target.parentNode.insertBefore(wrap, target.nextSibling);
  }

  function boot() {
    var current = handleFromPath();
    var list = read().filter(function (h) { return h !== current; }).slice(0, MAX_SHOW);
    remember(current);
    if (!list.length) return;

    Promise.all(
      list.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (results) {
      render(results.filter(Boolean));
    });
  }

  if (!/\/products\//.test(window.location.pathname)) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
